/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  /* footer extend */
  document.querySelectorAll('.footer__block--menu').forEach(function (menuBlock) {
    const header = menuBlock.querySelector('.footer__block__title');
    const content = menuBlock.querySelector('.footer__quicklinks');
  
    header.addEventListener('click', function () {
      content.style.display = (content.style.display === 'block') ? 'none' : 'block';
      header.classList.toggle('active');
    });
  });


})();


/* Quick add - bigger tap area around the plus (14px each side, invisible); YMAL size boxes match home page widths; close size boxes once a size is picked so they don't sit over the cart drawer */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.related-extended .floating-swatches-wrapper .radio__fieldset .radio__button { flex: 0 0 auto !important; width: auto !important; min-width: 0 !important; max-width: none !important; }' +
    '.related-extended .floating-swatches-wrapper .radio__fieldset .radio__button label { width: auto !important; min-width: 0 !important; }' +
    '.product-item .btn-add-to-cart::after { content: ""; position: absolute; top: -14px; right: -14px; bottom: -14px; left: -14px; }';
  document.head.appendChild(style);

  function closeQuickAdd() {
    document.querySelectorAll('.btn-add-to-cart.clicked').forEach(function (btn) {
      btn.classList.remove('clicked');
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.floating-swatches-wrapper')) {
      setTimeout(closeQuickAdd, 300);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.floating-swatches-wrapper .product__submit__add')) {
      setTimeout(closeQuickAdd, 300);
    }
  }, true);
})();
